export function shouldEnableAppRealtime(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/dashboard" ||
    pathname === "/requests" ||
    pathname.startsWith("/requests/")
  );
}
